module.exports = __webpack_public_path__ + "static/media/closeWhite.c144f40c.svg";